<label class="sonder-option-disc-wrapper">
  <ng-content></ng-content>
  <div class="sonder-option-disc">
    <span class="sonder-option-disc-message" [innerHTML]="label"></span>
  </div>
</label>